import React, { FC } from 'react';
import { Typography, Box } from '@material-ui/core';
import { useStyles } from '../styles';
import { ISession } from '../../../../../types';
import {
  getDayOfWeek,
  getLocalDate,
  getLocalTime,
  getFullDate,
} from '../../../../../utils/dateUtils';
import { ReactComponent as ClockSVG } from '../assets/clock.svg';
import { ReactComponent as CalendarSVG } from '../assets/calendar.svg';

interface SessionDetailsProps {
  session: ISession;
}

const SessionDetails: FC<SessionDetailsProps> = ({ session }) => {
  const classes = useStyles({});

  const sessionDate = session.startsAt;
  const formattedTime = getLocalDate(sessionDate).concat(
    ' ',
    getLocalTime(sessionDate),
  );
  const formattedSessionDate = getDayOfWeek(sessionDate).concat(
    getFullDate(sessionDate),
  );

  return (
    <Box>
      <Typography key={session.id} variant="body1" className={classes.label}>
        {session.name}
      </Typography>
      <Box className={classes.sessionIconsContainer}>
        <Box className={classes.sessionItem}>
          <Typography
            component="span"
            variant="body1"
            className={classes.iconWrapper}
          >
            <CalendarSVG className={classes.icon} />
          </Typography>
          <Typography
            component="span"
            variant="body1"
            className={classes.iconLabel}
          >
            {formattedSessionDate}
          </Typography>
        </Box>
        <Box>
          <Typography
            component="span"
            variant="body1"
            className={classes.iconWrapper}
          >
            <ClockSVG className={classes.icon} />
          </Typography>
          <Typography
            component="span"
            variant="body1"
            className={classes.iconLabel}
          >
            {formattedTime}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default SessionDetails;
